import React from "react";
import { Row, Col } from "antd";
import moment from "moment";
import CardHeader from "../../../components/atoms/cardHeader";

export const TransactionHistory = ({ data }) => {

  return (
    <>
      <div className="card card-custom mb-5">
        <CardHeader name={"Transaction History"} />
        <div className="card-body p-0 border-1 border-light-dark border">
          <Row gutter={[30, 30]}>
            <Col className="gutter-row" xs={24} lg={16}>
              <div className="table-responsive">
                <table className="table table-borderless font-weight-bolder">
                  <tbody>
                    <tr>
                      <td>
                        <tr>
                          <td className="">Payment Method</td>
                        </tr>
                        <tr>
                          {" "}
                          <td className="">Created date</td>{" "}
                        </tr>
                        <tr>
                          {" "}
                          <td className="">Transaction Type</td>
                        </tr>
                        <tr>
                          <td className="">Status</td>
                        </tr>
                      </td>
                      {data?.length > 0 &&
                        data?.map((val) => {
                          return (
                            <>
                              <td style={{ borderLeft: "1px solid #ccc" }}>
                                <tr>
                                  <td className="">
                                    <span className="text-muted">
                                      {val?.paymentMethod}
                                    </span>
                                  </td>
                                </tr>
                                <tr>
                                  <td className="">
                                    <span className="text-muted">
                                      {moment
                                        .utc(val?.orderCreatedDate)
                                        .local()
                                        .format("DD/MM/YYYY")}
                                    </span>
                                  </td>
                                </tr>
                                <tr>
                                  <td className="">
                                    <span className="text-muted">
                                      {val?.transactionType}
                                    </span>
                                  </td>
                                </tr>
                                <tr>
                                  <td className="">
                                    <span className="text-muted">
                                      {val?.paidStatus ? "DONE" : "IN-COMPLETE"}
                                    </span>
                                  </td>
                                </tr>
                              </td>
                              <hr />
                            </>
                          );
                        })}
                    </tr>
                  </tbody>
                </table>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};
